import { render, staticRenderFns } from "./_cardDetail.vue?vue&type=template&id=77c35aeb&scoped=true&"
import script from "./_cardDetail.vue?vue&type=script&lang=js&"
export * from "./_cardDetail.vue?vue&type=script&lang=js&"
import style0 from "./_cardDetail.vue?vue&type=style&index=0&id=77c35aeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c35aeb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VIcon,VRow})
